import { render, staticRenderFns } from "./GeneralLedgerTable.vue?vue&type=template&id=74a8db13&scoped=true&"
import script from "./GeneralLedgerTable.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLedgerTable.vue?vue&type=style&index=0&id=74a8db13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a8db13",
  null
  
)

export default component.exports